const ERRORS = {
  PRESIGNED: { CONFIG: 'No se ha configurado la presigned' },
};

export default ERRORS;
